import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect, useDispatch, useSelector } from "react-redux";

import { imagesUrl, logoAdicionalUrl } from "../../shared/config";

import { logout } from "../../shared/store/auth";

import { styled } from "@mui/material/styles";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MuiAppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Badge from "@mui/material/Badge";

import MenuItem from "@mui/material/MenuItem";
import { IconButton } from "@mui/material";

import MailIcon from "@mui/icons-material/MailOutline";
import Menu from "../components/DropdownMenu";
import SearchBar from "../components/SearchBar";
import MoodFeedback from "../../features/misc/components/MoodFeedback";
import { ManageAccounts, School } from "@mui/icons-material";
import _cookies from "../../shared/utils/_cookies";
import TogglePushNotifications from "../../features/misc/components/TogglePushNotifications";
import { useNavMenuOptions } from "../../features/app/api/getNavMenuOptions";

const LogoutConfirmationDialog = ({ children }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const openDialog = () => {
    setDialogOpen(true);
  };
  const closeDialog = () => {
    setDialogOpen(false);
  };
  const handleConfirm = async () => {
    await dispatch(logout(auth?.user?.alunoid, auth?.token));
    window.location.reload();
  };
  return (
    <>
      {children({ openDialog, closeDialog })}
      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>Sair</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza que deseja fechar sua sessão? Você tem a opção de apenas
            fechar essa janela e manter sua sessão aberta e isso traz muitas
            vantagens! Além de não consumir nenhum recurso do seu dispositivo,
            ao retornar você não precisará logar novamente, suas metas de
            engajamento sobem e seus líderes poderão acompanhar melhor seu uso
            dentro da plataforma!
          </DialogContentText>
          <DialogActions>
            <Button onClick={handleConfirm}>
              Sim, desejo realmente fechar minha sessão!
            </Button>
            <Button onClick={closeDialog} variant="contained">
              Manter sessão, vou apenas fechar essa janela!
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </>
  );
};

const Logo = styled("img")(({ theme }) => ({
  objectFit: "contain",
  marginRight: 0,
  width: 120,
  height: 40,
}));

function AppBar({ auth, mail, params, ...props }) {
  const [anchorEl, setAnchorEl] = useState(null);

  const navigate = useNavigate();
  const menuOptionsQuery = useNavMenuOptions();
  const userName = auth?.user?.nome?.toUpperCase() || "User"?.toUpperCase();
  const userImage = `${imagesUrl}/${auth?.user?.foto}`;

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleGestor = () => {
    setAnchorEl(null);
    window.open(
      `${window.location.origin}/REDIRECT_GESTOR.ASPX?token=${auth?.token}`,
      "_blank"
    );
  };

  const handleProfileButtonClick = (event) => {
    handleMenuClose(event);
    navigate("/profile");
  };

  const handleMailClick = (event) => {
    handleMenuClose(event);
    navigate("/mail");
  };

  const theme = useTheme();
  const breakString = theme.breakpoints.up("md");
  const isDisplayMedium = useMediaQuery(breakString);

  const renderLogo = (
    <Logo
      sx={{
        marginLeft: { xs: "0px", sm: "0px" },
        display: { xs: "none", sm: "flex" },
        "&:hover": { cursor: "pointer" },
      }}
      src={params?.LOGOMARCA ? `${logoAdicionalUrl}${params.LOGOMARCA}` : null}
      alt="Logo da plataforma"
      onClick={() => {
        navigate("/");
      }}
    />
  );

  const renderLogoCompany = (
    <Logo
      sx={{
        marginLeft: { xs: "0px", sm: "12px" },
        display: { xs: "none", sm: "flex" },
        "&:hover": { cursor: "pointer" },
      }}
      src={
        params?.logomarca_adicional
          ? `${logoAdicionalUrl}${params.logomarca_adicional}`
          : null
      }
      onClick={() => {
        navigate("/");
      }}
    />
  );

  //Main Menu
  const menuId = "primary-search-account-menu";
  const isMenuOpen = Boolean(anchorEl);
  const renderMenu = (
    <Menu anchorEl={anchorEl} open={isMenuOpen} onClose={handleMenuClose}>
      <MenuItem onClick={handleProfileButtonClick}>Perfil</MenuItem>
      {menuOptionsQuery.data?.some(
        (opt) => opt?.ferramenta === "DASHBOARD"
      ) && (
        <MenuItem
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          Dashboard
        </MenuItem>
      )}
      {auth?.user?.profile?.isGestorAluno && (
        <MenuItem onClick={handleGestor}>Módulo Gestão</MenuItem>
      )}
      <LogoutConfirmationDialog>
        {({ openDialog }) => <MenuItem onClick={openDialog}>Sair</MenuItem>}
      </LogoutConfirmationDialog>
    </Menu>
  );

  //Mobile Menu

  const userChipId = "user-chip";
  const renderUserChip = (
    <Button
      sx={{
        padding: "0px !important",
        display: "flex",
        justifyContent: "space-between",
      }}
      onClick={handleProfileMenuOpen}
      id={userChipId}
      aria-label="account of current user"
      aria-controls={menuId}
      aria-haspopup="true"
    >
      <Avatar
        sx={{ height: "36px", width: "36px" }}
        src={userImage}
        alt={userName}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "2px",
        }}
      >
        {!!_cookies.getItem("auth")?.user?.profile?.isGestor?.ID && (
          <Box
            sx={{
              color: "black",
              backgroundColor: "white",
              height: "20px",
              width: "20px",
              borderRadius: "9999px 0 0 9999px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <School size="small" sx={{ fontSize: "15px" }} />
          </Box>
        )}
        {!!_cookies.getItem("auth")?.user?.profile?.isProfessor?.ID && (
          <Box
            sx={{
              color: "black",
              backgroundColor: "white",
              height: "20px",
              width: "20px",
              borderRadius: "9999px 0 0 9999px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ManageAccounts size="small" sx={{ fontSize: "15px" }} />
          </Box>
        )}
      </Box>
    </Button>
  );

  return (
    <MuiAppBar
      elevation={0}
      // disableGutters
      sx={{
        backgroundColor: "menu.backgroundheader",
        ".MuiIconButton-colorPrimary": {
          // display: "none",  color: "white",
          color: "primary.main",
          backgroundColor: "white",
          "&:hover": {
            backgroundColor: "primary.main",
            color: "white",
          },
        },
        padding: "0px",
      }}
      position="static"
    >
      <Container
        disableGutters
        maxWidth="100%"
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            height: "60px",
            padding: "0 24px",
            alignItems: "center",
          }}
        >
          {renderLogo}
          {params?.logomarca_adicional ? renderLogoCompany : null}
        </Box>
        <Toolbar
          disableGutters
          sx={{
            paddingLeft: 2,
            display: "flex",
            justifyContent: "space-between",
            height: "60px",
          }}
        >
          <Box sx={{ flexGrow: "2" }}>
            <SearchBar sx={{ width: "100%" }} />
          </Box>
          <Box
            sx={{
              paddingLeft: 1,
              display: "flex",
              gap: 1,
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Badge badgeContent={mail.unread} color="error">
              <IconButton
                sx={{
                  height: "36px",
                  width: "36px",
                }}
                size={isDisplayMedium ? "large" : "small"}
                aria-label="show 13 new notifications"
                onClick={handleMailClick}
              >
                <MailIcon />
              </IconButton>
            </Badge>
            <TogglePushNotifications />
            <MoodFeedback />
            {renderUserChip}
          </Box>
        </Toolbar>
        {renderMenu}
      </Container>
    </MuiAppBar>
  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    params: state.app.params,
    mail: state.mail,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logout,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AppBar);
